module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "summary-wrapper"
  }, [_c('navbar', {
    attrs: {
      "title": "货品汇总-选择餐企"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "summary-filter-shell",
    staticStyle: {
      "background": "none"
    }
  }, _vm._l((_vm.restaurantDetails), function(restaurantDetail, index) {
    return _c('div', [_c('p', {
      staticClass: "summary-filter-p"
    }, [_vm._v(_vm._s(restaurantDetail.phonetic))]), _vm._v(" "), _c('ul', {
      staticClass: "summary-filter-ul summary-company-select-ul"
    }, [_c('li', {
      on: {
        "click": function($event) {
          return _vm.selectCompany(restaurantDetail.restaurant_id, restaurantDetail.name)
        }
      }
    }, [_c('label', [_vm._v(_vm._s(restaurantDetail.name) + " \r\n\t\t\t\t\t\t\t"), (_vm.selectJudge(restaurantDetail.restaurant_id)) ? _c('input', {
      attrs: {
        "type": "radio",
        "name": "selectCompany",
        "checked": ""
      }
    }) : _c('input', {
      attrs: {
        "type": "radio",
        "name": "selectCompany"
      }
    })])])])])
  }), 0)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cb168e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CompanySelect.vue
// module id = 596
// module chunks = 1